export const generateApiParameters = (pixel) => {
  const parameterInformation = [
    {
      parameter: 'pid',
      type: 'string',
      required: 'YES',
      description: `This is the Pixel ID of your website.  Your Pixel ID is: ${pixel.data && pixel.data.uuid}`
    },
    {
      parameter: 'uid',
      type: 'string',
      required: 'YES',
      description: `Your user's unique ID to help us identify the user.  When we retrieve our job ads we use the
      user's search history to provide the most relevant results.  Do not use the same ID for multiple users of your website.`
    },
    {
      parameter: 'ip',
      type: 'string',
      required: 'YES',
      description: `Your users IP Address.  Do not use the same IP address for multiple users.  
        You should be retrieving a different IP address for each different user`
    },
    {
      parameter: 'useragent',
      type: 'string',
      required: 'YES',
      description: `The useragent your user is using to access your backend.  This is often a web browser or a mobile app.  
      The useragent could be a web browser such as Google Chrome, or Mozilla Firefox`
    },
    {
      parameter: 'keyword',
      type: 'string',
      required: 'YES',
      description: 'The search keyword.  This can be a job title, company name or industry'
    },
    {
      parameter: 'location',
      type: 'string',
      required: 'YES',
      description: 'The location of your user.  This can be a city, region or zipcode'
    },
    {
      parameter: 'slots',
      type: 'integer',
      required: '',
      description: `The number of job ads we will send back.  
      If you do not pass a slots value the API will send back the number you have set as your default template for your website`
    },
    {
      parameter: 'ref_url',
      type: 'string',
      required: '',
      description: 'The origin url of the HTTP request.'
    },
    {
      parameter: 'url',
      type: 'string',
      required: '',
      description: 'The HTTP url where the auction was triggered from.  This is usually the search page of your job board.'
    }
  ];

  return parameterInformation;
};
